import React from 'react';

const LevelPage = React.lazy(() => import('pages/Level/LevelPage'));
const LevelAddPage = React.lazy(() => import('pages/Level/LevelAddPage'));

const LevelRoutes = [
  {
    path: '/level',
    exact: true,
    name: 'Danh sách Level nhân viên',
    function: 'HR_LEVEL_VIEW',
    component: LevelPage,
  },
  {
    path: '/level/add',
    exact: true,
    name: 'Thêm Level nhân viên',
    function: 'HR_LEVEL_ADD',
    component: LevelAddPage,
  },
  {
    path: '/level/detail/:level_id',
    exact: true,
    name: 'Chi tiết Level nhân viên',
    function: 'HR_LEVEL_VIEW',
    component: LevelAddPage,
  },
  {
    path: '/level/edit/:level_id',
    exact: true,
    name: 'Chỉnh sửa Level nhân viên',
    function: 'HR_LEVEL_EDIT',
    component: LevelAddPage,
  },
];

export default LevelRoutes;
